export default {
  title: 'Find something you love!',
  description: 'Your orders will be listed here.',
  buttons: {
    order_now: 'Order now',
  },
};
